<template>
  <div class="supplier-orders-confirm-container">
    <!-- 顶部标题栏 -->
    <div class="page-header">
      <div class="header-title">
        <div class="title-mark"></div>
        <span>确认订单</span>
      </div>
      <div class="back-button" @click="goBack">
        <i class="el-icon-arrow-left"></i>
        返回
      </div>
    </div>
    
    <!-- 订单基本信息 -->
    <div class="order-basic-info">
      <div class="info-item">
        <span class="label">订单号：</span>
        <span class="value">{{ orderInfo.orderNumber }}</span>
      </div>
      <div class="info-item">
        <span class="label">总价：</span>
        <span class="value">{{ formatAmount(orderInfo.totalPrice) }}</span>
      </div>
      <div class="info-item">
        <span class="label">客户方名称：</span>
        <span class="value">{{ orderInfo.customerName }}</span>
      </div>
    </div>
    
    <!-- 收货人信息 -->
    <div class="receiver-info-box">
      <div class="section-title">收货人信息</div>
      <div class="receiver-info">
        <div class="info-row">
          <div class="info-col">
            <span class="label">收货人：</span>
            <span class="value">{{ orderInfo.receiverInfo.name }}</span>
          </div>
          <div class="info-col">
            <span class="label">联系电话：</span>
            <span class="value">{{ orderInfo.receiverInfo.phone }}</span>
          </div>
        </div>
        <div class="info-row">
          <div class="info-col full-width">
            <span class="label">收货地址：</span>
            <span class="value">{{ orderInfo.receiverInfo.address }}</span>
          </div>
        </div>
      </div>
    </div>
    
    <!-- 商品信息 -->
    <div class="product-info-box">
      <div class="section-title">商品信息</div>
      <el-table
        :data="orderInfo.products"
        border
        style="width: 100%"
        :header-cell-style="{ background: '#f5f7fa', color: '#606266' }"
      >
        <el-table-column
          prop="name"
          label="商品信息"
          min-width="180"
        >
          <template slot-scope="scope">
            <div>{{ scope.row.name }}</div>
            <div class="product-spec">品牌：{{ scope.row.brand }}，颜色：{{ scope.row.color }}</div>
          </template>
        </el-table-column>
        
        <el-table-column
          prop="specification"
          label="规格型号"
          width="180"
        >
          <template slot-scope="scope">
            <el-tooltip
              v-if="scope.row.specification"
              :content="scope.row.specification"
              placement="top"
              effect="dark"
              popper-class="spec-tooltip"
            >
              <span>{{ truncateText(scope.row.specification, 20) }}</span>
            </el-tooltip>
            <span v-else>-</span>
          </template>
        </el-table-column>
        
        <el-table-column
          prop="unit"
          label="单位"
          width="80"
          align="center"
        ></el-table-column>
        
        <el-table-column
          prop="quantity"
          label="数量"
          width="80"
          align="center"
        ></el-table-column>
        
        <el-table-column
          prop="price"
          label="税前单价"
          width="120"
          align="center"
        ></el-table-column>
        
        <el-table-column
          prop="taxRate"
          label="税率"
          width="100"
          align="center"
        ></el-table-column>
        
        <el-table-column
          prop="priceWithTax"
          label="含税单价"
          width="120"
          align="center"
        ></el-table-column>
      </el-table>
    </div>
    
    <!-- 底部按钮 -->
    <div class="action-buttons">
      <el-button type="primary" @click="acceptOrder">订单接受</el-button>
      <el-button @click="cancelOrder">取消</el-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SupplierOrdersConfirm',
  data() {
    return {
      orderId: null,
      orderInfo: {
        orderNumber: '6655560013',
        totalPrice: 78.6,
        customerName: '宏源盛世科技有限公司',
        receiverInfo: {
          name: '任量丁',
          phone: '18209841321',
          address: '广州市天河区 华强路 120号'
        },
        products: [
          {
            name: '水性油漆',
            brand: '不限',
            color: '综合',
            specification: '品牌：不限，颜色：综合',
            unit: 'KG',
            quantity: 3,
            price: 5.80,
            taxRate: '13%',
            priceWithTax: 6.55
          },
          {
            name: '水性油漆',
            brand: '不限',
            color: '综合',
            specification: '品牌：不限，颜色：综合',
            unit: 'KG',
            quantity: 3,
            price: 5.80,
            taxRate: '13%',
            priceWithTax: 6.55
          },
          {
            name: '水性油漆',
            brand: '不限',
            color: '综合',
            specification: '品牌：不限，颜色：综合',
            unit: 'KG',
            quantity: 3,
            price: 5.80,
            taxRate: '13%',
            priceWithTax: 6.55
          }
        ]
      }
    };
  },
  created() {
    // 从路由参数获取订单ID
    this.orderId = this.$route.params.id;
    // 实际项目中这里应该调用API获取订单详情
    this.getOrderDetail();
  },
  methods: {
    // 截断文本显示，默认为20个字符
    truncateText(text, length = 20) {
      if (!text) return '-';
      const str = String(text);
      return str.length > length ? `${str.slice(0, length)}...` : str;
    },

    // 格式化金额（带千位分隔符）
    formatAmount(amount) {
      if (amount === undefined || amount === null) return '0.00';
      const num = parseFloat(amount);
      if (isNaN(num)) return '0.00';
      return num.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    },

    // 获取订单详情
    getOrderDetail() {
      // 实际项目中这里应该调用API获取订单详情
      // this.$axios.get(`/api/supplier/orders/${this.orderId}`).then(response => {
      //   this.orderInfo = response.data;
      // }).catch(error => {
      //   this.$message.error('获取订单详情失败');
      // });
      
      // 这里使用模拟数据
    },
    
    // 接受订单
    acceptOrder() {
      this.$confirm('确认接受该订单?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // 实际项目中这里应该调用API
        // this.$axios.post(`/api/supplier/orders/${this.orderId}/accept`).then(response => {
        //   this.$message.success('订单已接受');
        //   this.$router.push('/orders/supplier-orders-list');
        // }).catch(error => {
        //   this.$message.error('接受订单失败');
        // });
        
        // 模拟API请求
        setTimeout(() => {
          this.$message.success('订单已接受');
          this.$router.push('/orders/supplier-orders-list');
        }, 500);
      }).catch(() => {
        this.$message.info('已取消接受');
      });
    },
    
    // 取消
    cancelOrder() {
      this.$router.push('/orders/supplier-orders-list');
    },
    
    // 返回
    goBack() {
      this.$router.go(-1);
    }
  }
};
</script>

<style lang="scss" scoped>
.supplier-orders-confirm-container {
  padding: 20px;
  background-color: #fff;
  
  .page-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
    
    .header-title {
      display: flex;
      align-items: center;
      
      .title-mark {
        width: 4px;
        height: 18px;
        background-color: #2c73eb;
        margin-right: 8px;
      }
      
      span {
        font-size: 18px;
        font-weight: 500;
        color: #303133;
      }
    }
    
    .back-button {
      cursor: pointer;
      color: #409EFF;
      display: flex;
      align-items: center;
      
      i {
        margin-right: 5px;
      }
    }
  }
  
  .order-basic-info {
    padding: 15px;
    background-color: #f8f8f8;
    border-radius: 4px;
    margin-bottom: 20px;
    display: flex;
    flex-wrap: wrap;
    
    .info-item {
      margin-right: 30px;
      margin-bottom: 5px;
      
      .label {
        color: #606266;
        margin-right: 5px;
      }
      
      .value {
        font-weight: 500;
        color: #303133;
      }
    }
  }
  
  .section-title {
    font-size: 16px;
    font-weight: 500;
    margin-bottom: 15px;
    color: #303133;
    border-left: 3px solid #2c73eb;
    padding-left: 10px;
  }
  
  .receiver-info-box {
    margin-bottom: 20px;
    
    .receiver-info {
      padding: 15px;
      border: 1px solid #ebeef5;
      border-radius: 4px;
      
      .info-row {
        display: flex;
        margin-bottom: 15px;
        
        &:last-child {
          margin-bottom: 0;
        }
        
        .info-col {
          flex: 1;
          
          &.full-width {
            width: 100%;
          }
          
          .label {
            color: #606266;
            margin-right: 5px;
          }
          
          .value {
            color: #303133;
          }
        }
      }
    }
  }
  
  .product-info-box {
    margin-bottom: 30px;
    
    .product-spec {
      color: #909399;
      font-size: 12px;
      margin-top: 5px;
    }
  }
  
  .action-buttons {
    display: flex;
    justify-content: center;
    margin-top: 30px;
    
    .el-button {
      padding: 12px 25px;
      margin: 0 15px;
    }
  }
}
</style> 

<style lang="scss">
.spec-tooltip {
  max-width: 600px !important;
  white-space: normal;
  word-break: break-all;
}
</style>